import { SystemIcon } from '@storeblocks/icon';
import { type FC } from 'react';
import styled from 'styled-components';

interface Props {
  direction: 'up' | 'down';
}

export const YieldIcon: FC<Props> = ({ direction }) => {
  return direction === 'up' ? (
    <StyledSystemIcon name="stat_ascend" isPhosphor />
  ) : (
    <StyledSystemIcon name="stat_descend" isPhosphor />
  );
};

const StyledSystemIcon = styled(SystemIcon)`
  font-size: 24px;
  line-height: 24px;
`;
